import axios from 'axios';
import { saveAs } from 'file-saver';

const BASE_URL = process.env.VUE_APP_APIURL;

const getTransferPdf = (url, options) => axios.get(url, { responseType: 'blob', ...options });

const getFileNameFromContentDisposition = (contentDisposition, fallback) => {
    if (!contentDisposition) return fallback;
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition);
    return match ? decodeURIComponent(match[1]) : fallback;
};

// Saves a blob response using its actual Content-Type/Content-Disposition (falls back to
// fallbackFileName's extension for the mime type, and to fallbackFileName itself) instead of
// assuming the file is always a PDF.
const saveResponseFile = (response, fallbackFileName) => {
    if (!response?.data) return;
    const contentType = response.headers?.['content-type'] || 'application/octet-stream';
    const fileName = getFileNameFromContentDisposition(response.headers?.['content-disposition'], fallbackFileName);
    const blob = new Blob([response.data], { type: contentType });
    saveAs(blob, fileName);
};

const isBrowserViewable = (contentType) => contentType.includes('pdf') || contentType.startsWith('image/');

// Fetches a protected file (with the auth token) and shows it in a new tab; files the browser
// can't display (e.g. docx) are downloaded instead. The tab is opened synchronously, before the
// request, so popup blockers don't block it.
const openFileInNewTab = (url, fallbackFileName) => {
    const newTab = window.open('', '_blank');
    return getTransferPdf(url)
        .then((response) => {
            const contentType = response.headers?.['content-type'] || '';
            if (newTab && isBrowserViewable(contentType)) {
                const blob = new Blob([response.data], { type: contentType });
                newTab.location.href = URL.createObjectURL(blob);
                return;
            }
            if (newTab) newTab.close();
            saveResponseFile(response, fallbackFileName);
        })
        .catch((error) => {
            if (newTab) newTab.close();
            throw error;
        });
};

const postData = (data) => axios.post(`${BASE_URL}/api/ExcelData/ToXls`, data, { responseType: 'blob' });
const getData = (file) => axios.post(`${BASE_URL}/api/ExcelData`, file, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});
const uploadTollRoadExcel = (file, data) => axios.post(`${BASE_URL}/api/TollRoadReports/Batch/${data.type}?comment=${data.comment}&fileName=${data.filename}`, file, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});
const downloadBatchFile = (batchId) => axios.get(`${BASE_URL}/api/Reports/batch/crawl/${batchId}`, {
    responseType: 'blob',
});

const analyzeFineCenter = (file) => axios.post(`${BASE_URL}/api/Reports/FineCenter/Analyze`, file, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

export default {
    getTransferPdf,
    uploadTollRoadExcel,
    getData,
    postData,
    downloadBatchFile,
    analyzeFineCenter,
    saveResponseFile,
    openFileInNewTab,
};
